<!-- ══ Sub-nav ═══════════════════════════════════════════════════════ -->
<nav class="pmr-subnav">
  <div class="pmr-subnav__brand" (click)="goBack()" role="button" tabindex="0">
    <svg width="30" height="30" viewBox="0 0 44 44" fill="none">
      <defs>
        <linearGradient id="policyBagGrad" x1="0" y1="0" x2="44" y2="44" gradientUnits="userSpaceOnUse">
          <stop stop-color="#3E79CE" />
          <stop offset="1" stop-color="#699F53" />
        </linearGradient>
      </defs>
      <path d="M9 19 C8.4 19 7.9 19.5 7.8 20.1 L6.2 38 Q6.1 39.5 7.6 39.5 L36.4 39.5 Q37.9 39.5 37.8 38 L36.2 20.1 C36.1 19.5 35.6 19 35 19 Z" fill="url(#policyBagGrad)" />
      <path d="M16.5 19 C16.5 12 27.5 12 27.5 19" stroke="url(#policyBagGrad)" stroke-width="2.5" fill="none" stroke-linecap="round" />
      <path d="M15 29.5 L20.5 35 L30 23" stroke="white" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
    <span class="pmr-subnav__brand-text">PickMe<span class="pmr-gradient-text">Right</span></span>
  </div>

  <div class="pmr-subnav__actions">
    <button class="pmr-subnav__back" type="button" (click)="goBack()">
      <i class="fas fa-arrow-left"></i>
      <span>Back home</span>
    </button>
  </div>
</nav>

<!-- ══ Page head ═════════════════════════════════════════════════════ -->
<header class="pmr-phead">
  <div class="pmr-container">
    <p class="pmr-crumb"><a (click)="goBack()">Home</a> <span>·</span> Policies</p>
    <h1 class="pmr-phead__title">Policies</h1>
    <p class="pmr-phead__sub">
      Everything that governs how PickMeRight works — what we do with your data, how reviews
      are handled, what we send you, and what to do if something goes wrong. Written to be read,
      not skimmed past.
    </p>
  </div>
</header>

<!-- ══ Body ══════════════════════════════════════════════════════════ -->
<div class="pmr-container">
  <div class="pmr-plyt">

    <!-- Sidebar (desktop) -->
    <aside class="pmr-side">
      <h4>For everyone</h4>
      <ul>
        <li *ngFor="let doc of orderedDocs; trackBy: trackByDocId">
          <button type="button" class="pmr-side__item" [class.pmr-side__item--active]="activeId === doc.id"
            (click)="selectDoc(doc.id)">
            <span class="pmr-side__icon"><i class="fas" [ngClass]="doc.icon"></i></span>
            <span class="pmr-side__body">
              <span class="pmr-side__title">{{ doc.title }}</span>
              <span class="pmr-side__date">{{ doc.updated }}</span>
            </span>
          </button>
        </li>
      </ul>
      <div class="pmr-side__note">
        <b>Something not clear?</b>
        Write to {{ contact.email.value }} and we will explain it in plain terms.
      </div>
    </aside>

    <main class="pmr-main">
      <!-- Mobile picker -->
      <div class="pmr-picker">
        <label for="pmrDocPick">Choose a policy</label>
        <select id="pmrDocPick" [value]="activeId" (change)="onPickerChange($event)">
          <optgroup label="For everyone">
            <option *ngFor="let doc of orderedDocs" [value]="doc.id">{{ doc.title }}</option>
          </optgroup>
        </select>
      </div>

      <!-- Document -->
      <article class="pmr-doc" id="pmrDocPanel" tabindex="-1" *ngIf="activeDoc as doc">
        <div class="pmr-doc__meta">
          <span class="pmr-chip pmr-chip--live">Published</span>
          <span class="pmr-chip">{{ doc.href }}</span>
        </div>
        <h2 class="pmr-doc__title">{{ doc.title }}</h2>
        <p class="pmr-doc__intro">{{ doc.intro }}</p>
        <p class="pmr-doc__updated">Last updated {{ doc.updated }}</p>

        <section *ngFor="let block of doc.body" [class.pmr-doc__section--hl]="block.hl">
          <ng-container *ngTemplateOutlet="blockTpl; context: { $implicit: block, level: 2 }"></ng-container>
        </section>

        <div class="pmr-doc__foot">
          <div>
            <b>Email</b>
            <span><a [href]="contact.email.href" target="_blank" rel="noopener noreferrer">{{ contact.email.value }}</a></span>
          </div>
          <div>
            <b>Phone</b>
            <span><a [href]="contact.phone.href">{{ contact.phone.value }}</a></span>
          </div>
          <div>
            <b>Location</b>
            <span>{{ contact.place.value }}</span>
          </div>
          <div>
            <b>Published by</b>
            <span><a [href]="publisher.url" target="_blank" rel="noopener">{{ publisher.name }}</a> · {{ publisher.location }}</span>
          </div>
          <div>
            <b>Version history</b>
            <span>1.0 · {{ doc.updated }} · first published</span>
          </div>
        </div>
      </article>
    </main>

  </div>
</div>

<!-- ══ Recursive block renderer ═════════════════════════════════════
     Mirrors the original blockInto() — headings, paragraphs, lists,
     tables, consent cards and callouts, with sub-blocks nested one
     level deeper (h3 → h4). ══════════════════════════════════════ -->
<ng-template #blockTpl let-b let-level="level">
  <h3 *ngIf="b.h && level === 2">{{ b.h }}</h3>
  <h4 *ngIf="b.h && level === 3">{{ b.h }}</h4>

  <p *ngFor="let t of b.p">{{ t }}</p>

  <ul *ngIf="b.list">
    <li *ngFor="let t of b.list">{{ t }}</li>
  </ul>

  <div class="pmr-tblwrap" *ngIf="b.table">
    <table>
      <thead>
        <tr>
          <th *ngFor="let head of b.table.head">{{ head }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of b.table.rows; let i = index" [class.pmr-tr--hl]="b.table.hl && b.table.hl.includes(i)">
          <td *ngFor="let cell of row">
            <ng-container *ngIf="isEmail(cell); else normalCell">
              <a
                [href]="getEmailLink(cell)"
                target="_blank"
                rel="noopener noreferrer"
                class="pmr-email-link"
              >
                {{ cell }}
              </a>
            </ng-container>

            <ng-template #normalCell>
              {{ cell }}
            </ng-template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="pmr-consents" *ngIf="b.consents">
    <div class="pmr-consent" *ngFor="let c of b.consents">
      <span class="pmr-consent__box"></span>
      <div>
        <b>{{ c.t }}</b>
        <span>{{ c.d }}</span>
      </div>
    </div>
  </div>
  <p class="pmr-consent-note" *ngIf="b.consentNote">{{ b.consentNote }}</p>

  <div class="pmr-callout" *ngIf="b.callout">
    <strong>{{ b.callout.t }}</strong>
    <p *ngFor="let t of b.callout.b">{{ t }}</p>
  </div>

  <ng-container *ngFor="let sub of b.sub">
    <ng-container *ngTemplateOutlet="blockTpl; context: { $implicit: sub, level: 3 }"></ng-container>
  </ng-container>

  <p *ngFor="let t of b.after">{{ t }}</p>
</ng-template>

<!-- ══ Footer ════════════════════════════════════════════════════════ -->
<footer class="pmr-footer">
  <div class="pmr-container pmr-footer__inner">
    <div class="pmr-footer__brand">
      <svg width="22" height="22" viewBox="0 0 44 44" fill="none">
        <defs>
          <linearGradient id="policyBagGradFoot" x1="0" y1="0" x2="44" y2="44" gradientUnits="userSpaceOnUse">
            <stop stop-color="#3E79CE" />
            <stop offset="1" stop-color="#699F53" />
          </linearGradient>
        </defs>
        <path d="M9 19 C8.4 19 7.9 19.5 7.8 20.1 L6.2 38 Q6.1 39.5 7.6 39.5 L36.4 39.5 Q37.9 39.5 37.8 38 L36.2 20.1 C36.1 19.5 35.6 19 35 19 Z" fill="url(#policyBagGradFoot)" />
        <path d="M16.5 19 C16.5 12 27.5 12 27.5 19" stroke="url(#policyBagGradFoot)" stroke-width="2.5" fill="none" stroke-linecap="round" />
        <path d="M15 29.5 L20.5 35 L30 23" stroke="white" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <span>PickMeRight</span>
    </div>

    <nav class="pmr-footer__links">
      <a [routerLink]="['/policies', 'privacy']">Privacy &amp; data</a>
      <a [routerLink]="['/policies']">All policies</a>
      <a href="mailto:technoreachlabs2026@gmail.com">Help</a>
    </nav>

    <div class="pmr-footer__copy">© 2026 Technoreach Labs · Trichy, India </div>
  </div>
</footer>